module.exports = __webpack_public_path__ + "img/26.c1406103.png";